import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ContactAgence {
  static init() {
    const modules = document.querySelectorAll('[data-module="contact-agence"]');

    if (!modules.length) {
      return;
    }

    modules.forEach((module) => {
      const trigger = module.querySelector('[data-custom-select-trigger]');
      const dropdown = module.querySelector('[data-custom-select-dropdown]');
      const options = module.querySelectorAll('.contact-agence__custom-select-option');
      const input = module.querySelector('[data-custom-select-input]');
      const valueDisplay = module.querySelector('[data-custom-select-value]');
      const cards = module.querySelectorAll('.contact-agence__card');

      if (!trigger || !dropdown) return;

      // 1. Setup toggle for the custom dropdown
      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        ContactAgence.closeAllDropdowns();

        if (!isExpanded) {
          trigger.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('is-open');
        }
      });

      options.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.stopPropagation(); // prevent the outside-click handler from re-processing this click

          const value = option.dataset.value;
          const text = option.textContent.trim();

          options.forEach(opt => opt.setAttribute('aria-selected', 'false'));
          option.setAttribute('aria-selected', 'true');
          valueDisplay.textContent = text;
          input.value = value;

          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('is-open');

          ContactAgence.filterCards(value, cards);
        });
      });

      // 3. Initial filter state (on page load, run filter based on input value)
      ContactAgence.filterCards(input.value, cards);
    });

    // Close dropdowns globally when clicking outside
    document.addEventListener('click', () => {
      ContactAgence.closeAllDropdowns();
    });
  }

  static filterCards(value, cards) {
    cards.forEach((card) => {
      // IF the value is empty ("Toutes les villes") OR the card matches the city ID, show it.
      if (!value || card.dataset.agencyId === value) {
        card.classList.add('is-active');
        card.removeAttribute('hidden');
      } else {
        // Otherwise hide it.
        card.classList.remove('is-active');
        card.setAttribute('hidden', '');
      }
    });

    requestAnimationFrame(() => ScrollTrigger.refresh());
  }

  static closeAllDropdowns() {
    const allTriggers = document.querySelectorAll('[data-custom-select-trigger]');
    const allDropdowns = document.querySelectorAll('[data-custom-select-dropdown]');

    allTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    allDropdowns.forEach(d => d.classList.remove('is-open'));
  }
}